// A DatePicker holding text it cannot read keeps its previous value and flags
// itself with setCustomValidity. A native form submit stops on that; a save
// wired to a plain button does not, so it calls this first: the first flagged
// field inside `container` shows its message and the save is refused (true).
export function reportInvalidField(container) {
  if (!container) return false;
  const field = Array.from(
    container.querySelectorAll('input, select, textarea'),
  ).find((element) => element.validity?.customError);
  if (!field) return false;
  field.reportValidity();
  return true;
}
